<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Título</th>
        <th scope="col" class="border-0">Tipo</th>
        <th scope="col" class="border-0">Dificuldade</th>
        <th scope="col" class="border-0">Publicado em</th>
        <th scope="col" class="border-0">Grátis</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in puzzles" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-puzzle-edit', params: { puzzleId: row.id }}">{{ row.name }}</d-link>
        </td>
        <td class="td-3">{{ row.type.name ? row.type.name : '' }}</td>
        <td class="td-3">{{ row.level.name ? row.level.name : '' }}</td>
        <td class="td-2">{{ (row.f_published_date) ? row.f_published_date : '' }}</td>
        <td class="td-2">{{ (row.cat_id == 1) ? 'Sim' : 'Não' }}</td>
        <td class="td-2">
          <puzzle-buttons :puzzle="row"></puzzle-buttons>
        </td>
      </tr>
      <tr v-if="puzzles.length === 0">
        <td colspan="7" class="no-content">Ainda não tem nenhum jogo cadastrado.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de jogo"
      message="Tem certeza que deseja excluir esse jogo?"/>
  </table>
</template>

<script>
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import PuzzleButtons from './PuzzleButtons.vue';
import PuzzleDelete from './PuzzleDelete';
import { _DELETE_PUZZLE_ } from './PuzzleModel';

export default {
  name: 'puzzle-table',
  mixins: [PuzzleDelete],
  components: {
    PuzzleButtons,
    ConfirmationModal,
  },
  props: {
    puzzles: {
      type: Array,
    },
  },
  data() {
    return {
      selectPuzzle: null,
    };
  },
  mounted() {
    this._onDeletePuzzle = puzzle => { this.selectPuzzle = puzzle.id; };
    Events.$on(_DELETE_PUZZLE_, this._onDeletePuzzle);
  },
  beforeDestroy() {
    Events.$off(_DELETE_PUZZLE_, this._onDeletePuzzle);
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.td {
  &-2 {
    min-width: 140px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
